exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".px-3{padding:15px 0 15px 0}.py-3{border:1px solid #ccc;border-radius:10px;margin-bottom:15px}", ""]);

